import clsx from "clsx";
import Link from "next/link";

import Author from "@components/Author";
import getHref from "@lib/routes";

const Authors = ({ authors }) => {
  return (
    <div className={clsx("Authors", "flex flex-wrap", "space-x-7.5")}>
      {authors.map((author) => {
        const href = getHref(author);

        return (
          (<Link
            key={author.id}
            href={href}
            className={clsx(
              "Authors__author",
              "mt-7.5",
              "inline-block",
              "transition-colors",
              "hover:underline"
            )}>

            <Author
              name={author.title}
              image={author.image ? author.image[0] : null}
            />

          </Link>)
        );
      })}
    </div>
  );
};

export default Authors;
